import React from 'react'
import { PopoColored } from '@bedrock/icons-react'
import classNames from 'classnames/bind'
import styles from './index.less'
import { startPopoChat } from "@bedrock/utils";

const cx = classNames.bind(styles)

// 参考
// https://open.popo.netease.com/docs/common-service/popo-conversation
type Props = {
    /*sstp：
    0：p2p 会话（员工账号、机器人、值班号都属于 p2p 会话）；
    1: 群
    20：服务号；*/
    sstp?: 0 | 1 | 20,
    // ssid：p2p 会话使用泡泡账号，服务号使用服务号的账号名称，群会话使用群 id(群号)
    ssid: string,
} & Omit<React.HTMLAttributes<HTMLDivElement>, 'type' | 'onClick'>

export default function POPOChatIcon(props: Props) {
    const { ssid, sstp = 0, className, ...rest } = props;
    return <PopoColored className={cx('popo-icon', className)} onClick={() => {
        startPopoChat(ssid, sstp)
    }} {...rest} />
}
